import { IsNotEmpty, IsAlphanumeric, IsOptional, IsNumber } from "class-validator";
import { ApiProperty } from "@nestjs/swagger";
import { FindConditions, FindOperator } from "typeorm";

export class interviewRequest{
    [x: string]: any;

    @ApiProperty()
    @IsNotEmpty()
    @IsAlphanumeric()
    interviewId: number;

    @ApiProperty()
    @IsOptional()
    updatedUser: string;

    @ApiProperty()
    @IsOptional()
    @IsNumber()
    versionFlag: number;

    @ApiProperty()
    isActive: boolean;
   
}